import { GET_LENDER_PROFILE_ASSIGNMENT_TITLES } from './getLenderProfileAssignmentTitles';
import { UPSERT_LENDER_PROFILE_ASSIGNMENT_TITLES } from './upsertLenderProfileAssignmentTitles';

export const dealerManagementApi = {
  getLenderProfileAssignmentTitles: GET_LENDER_PROFILE_ASSIGNMENT_TITLES,
  upsertLenderProfileAssignmentTitles: UPSERT_LENDER_PROFILE_ASSIGNMENT_TITLES,
};
